<template>
  <v-navigation-drawer
    :mini-variant="$vuetify.breakpoint.smAndDown"
    mini-variant-width="40"
    permanent
    class="side-navigation-drawer"
    floating
    width="250"
  >
    <div class="pa-5 primary--text text-uppercase" v-if="!$vuetify.breakpoint.smAndDown && showName && !sideMenuDrop">
      {{ sideMenuHeader }}
    </div>
    <div class="pa-5 primary--text text-uppercase" v-if="!$vuetify.breakpoint.smAndDown && sideMenuDrop">
      <v-select
        :items="sideMenuDrop"
        :label="sideMenuHeader"
        item-value="cameraId"
        item-text="name"
        single-line
        @input="goToLocation"
      ></v-select>
    </div>
    <v-divider v-if="!$vuetify.breakpoint.smAndDown && showName"></v-divider>
    <v-list class="pa-0">
      <v-list-item
        :ripple="false"
        v-for="menu in menus"
        class="side-menu mb-0 pa-0"
        :class="{ 'side-menu-selected-item': menu.endpoint === currentEndpoint }"
        tile
        :key="menu.endpoint"
        @click="$emit('itemSelected', menu)"
      >
        <v-list-item-icon class="item-icon">
          <v-icon size="14" class="primary--text" v-html="menu.icon"></v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="primary--text menu-text text-uppercase">{{ $t(menu.name) }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: "SideMenu",
  props: {
    sideMenuHeader: {
      type: String,
    },
    menus: {
      type: Array,
    },
    currentEndpoint: {
      type: String,
    },
    showName: {
      default: true,
      type: Boolean,
    },
    sideMenuDrop: {
      type: Array,
    },
    path: {
      type: String,
    },
  },

  methods: {
    goToLocation(item) {
      
      this.$router.push({ path: `${this.path}${item}` });
    },
  },
};
</script>

<style lang="scss" scoped>
.side-menu-selected-item {
  background-color: #eeeeee;
  font-weight: 600;
  border-radius: 0 !important;
}
.side-navigation-drawer {
  top: 70px !important;
}
.item-icon {
  width: 50px;
  margin: auto !important;
  i {
    margin: auto;
  }
}
.menu-text {
  letter-spacing: 1px !important;
  font-size: 14px !important;
}
.side-menu:hover {
  width: 102%;
  border-radius: 0 !important;
}
.side-menu:focus {
  background-color: transparent;
  width: 102%;
  border-radius: 0 !important;
}
</style>
